const icon = require('vue-svgicon');
icon.register({
    'cart-tryon': {
        width: 16,
        height: 16,
        viewBox: '0 0 22 22',
        data: `<path pid="0" d="M19 22H3V12H0L11 0l11 12h-3v10zM4 21h14V11h1.7L11 1.5 2.3 11H4v10z"/><path pid="1" d="M7.1 13H6c0 2.8 2.2 5 5 5s5-2.2 5-5h-1.1c0 2.2-1.7 3.9-3.9 3.9S7.1 15.2 7.1 13z"/>`,
    },
});
